import React from "react";
import {Controller, useFormContext} from "react-hook-form";
import {Box, Colors, Container, Text} from "@bounce/shared/ui";
import {MenuItem, Select, TextField} from "../../../ui/components";
import {SegmentCategory} from "../../../apis/requests/segments/types";
import {MARKETING_SEGMENT_TYPES, SEGMENT_TYPE_INFO} from "./constants";
import {FormValues} from "./schema";

type Props = {
  category: SegmentCategory;
};

const DetailsCard = ({category}: Props) => {
  const {control, watch} = useFormContext<FormValues>();
  const segmentType = watch("type");

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: Colors.tertiary._100,
        borderRadius: "12px",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <Text variant="interDisplay600" size={16} sx={{color: Colors.grey._800}}>
        Details
      </Text>
      <Container row fullWidth sx={{gap: 2}}>
        <Box sx={{flex: 1}}>
          <Text size={12} sx={{color: Colors.grey._700, mb: 0.5}}>
            Name <span style={{color: Colors.red._700}}>*</span>
          </Text>
          <Controller
            name="name"
            control={control}
            render={({field: {ref, ...field}, fieldState}) => (
              <TextField
                {...field}
                inputRef={ref}
                fullWidth
                size="small"
                placeholder="Segment name"
                error={!!fieldState.error}
                sx={{backgroundColor: Colors.bw.white, borderRadius: "8px"}}
              />
            )}
          />
        </Box>
        <Box sx={{flex: 1}}>
          <Text size={12} sx={{color: Colors.grey._700, mb: 0.5}}>
            Description
          </Text>
          <Controller
            name="description"
            control={control}
            render={({field: {ref, ...field}}) => (
              <TextField
                {...field}
                inputRef={ref}
                fullWidth
                size="small"
                placeholder="Optional. Shown in the segments list."
                sx={{backgroundColor: Colors.bw.white, borderRadius: "8px"}}
              />
            )}
          />
        </Box>
      </Container>
      {category === "marketing" && (
        <Box>
          <Text size={12} sx={{color: Colors.grey._700, mb: 0.5}}>
            Type <span style={{color: Colors.red._700}}>*</span>
          </Text>
          <Container row fullWidth sx={{gap: 2, alignItems: "center", flexWrap: "nowrap"}}>
            <Box sx={{flex: 1}}>
              <Controller
                name="type"
                control={control}
                render={({field}) => (
                  <Select
                    {...field}
                    fullWidth
                    size="small"
                    sx={{backgroundColor: Colors.bw.white, borderRadius: "8px"}}
                  >
                    {MARKETING_SEGMENT_TYPES.map((type) => (
                      <MenuItem key={type} value={type}>
                        {SEGMENT_TYPE_INFO[type].label}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
            </Box>
            <Text size={12} sx={{flex: 1, color: Colors.grey._600}}>
              {SEGMENT_TYPE_INFO[segmentType].description}
            </Text>
          </Container>
        </Box>
      )}
    </Box>
  );
};

export default DetailsCard;
